import { UtilityBillByIdDTO } from "api";
import { anomalyTypes, anomalyTypesKeys, anomalyTypesValues, sitePeriodBlockedMessage } from "../consts";

const getAnomaliesMessage = (type: string, value: string, id: string) => ({
  anomalyType: type,
  message: type === "Site Period Blocked"
    ? sitePeriodBlockedMessage
    : anomalyTypesValues.includes(type)
      ? value
      : `${type} is ${value} different from the last bill uploaded for this utility provider`,
  previousBillGuid: id,
});

export const getAnomaliesData = (utilityBill: UtilityBillByIdDTO) => {
  const currentAnomalies = utilityBill.anomalies || [];

  return currentAnomalies.map((item: any) =>
    getAnomaliesMessage(
      item.message?.includes("Cost")
        ? "Cost"
        : anomalyTypesKeys.includes(item.anomalyType)
          ? anomalyTypes[item.anomalyType as keyof typeof anomalyTypes]
          : "Usage",
      anomalyTypesKeys.includes(item.anomalyType)
        ? item.message
        : item.message?.split(" ").pop(),
      item.previousBillGuid,
    ),
  );
}

